import {Flex, Form, Divider, Input} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useEffect} from 'react';

import {formatIndian} from '../../../utils/formatIndian';
import {roundToDecimal} from '../../netZero/constants/commonFunctions';

const DisplayCalculations: React.FC<{
  field: any;
  length: number;
  index?: number;
  asInput?: boolean;
}> = ({field, length, index, asInput}) => {
  const FI = useFormInstance();
  const {setFieldValue, getFieldValue} = FI;

  const values =
    field?.relatedKey?.map((item: string) => {
      const watchValue = getFieldValue(item);

      return typeof watchValue === 'object' &&
        !Array.isArray(watchValue) &&
        watchValue !== null
        ? watchValue?.value
        : watchValue ?? undefined;
    }) ?? [];

  const result = values.every((item: any) => {
    return !isNaN(item);
  })
    ? values.every((item: any) => {
        return item === 0;
      })
      ? 0
      : field?.roundTo
        ? roundToDecimal(field.formula(values), field?.roundTo).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 10,
              maximumFractionDigits: 10
            }
          )
        : roundToDecimal(field.formula(values), 2)
    : undefined;

  const displayResult = (result: any) => {
    return isNaN(result)
      ? 'NA'
      : !isFinite(result)
        ? 'NA'
        : result < 0
          ? 'NA'
          : `${
              field?.units === '%' && result > 100 ? 'NA' : formatIndian(result)
            }`;
  };

  const mainResult = displayResult(result);

  // const isDivider = index !== length - 1 && index !== 4;
  // setFieldsValue({[field.fieldName]: result});

  const fieldValue =
    field?.units === '%' && mainResult === 'NA' ? 'NIL' : result;

  const isDivider = index !== length - 1 && index !== 4;
  useEffect(() => {
    if (field.fieldName) {
      setFieldValue(field.fieldName, fieldValue);
    }
  }, [fieldValue]);

  if (asInput) {
    return (
      <Form.Item
        name={field.fieldName}
        label={field.fieldLabel}
        tooltip={field?.tooltip}
        noStyle
      >
        <Input className="display-only-input" readOnly value={mainResult} />
      </Form.Item>
    );
  }

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      className="displayCalculationsMain"
      style={{
        width:
          length % 5 === 0
            ? '20%'
            : length >= 5
              ? '20%'
              : `${((1 / length) * 100).toFixed(2)}%`
      }}
    >
      <Flex className="displayFlex">
        <Form.Item name={field.fieldName} noStyle>
          <div className={`resultFlex ${mainResult === 'NA' ? 'error' : 'go'}`}>
            {`${mainResult} ${field?.units ? field?.units : ''}`}
          </div>
        </Form.Item>
        <div className="labelDisplay">{field.fieldLabel}</div>
      </Flex>
      {isDivider ? (
        <Divider type="vertical" className="verticalDivider" />
      ) : (
        <div></div>
      )}
    </Flex>
  );
};

export default React.memo(DisplayCalculations);
